import React from 'react';


class Header extends React.Component{

    _planetRef = React.createRef();
    _holeRef = React.createRef();

    state = {
        menu_open: false
    }

    goPlanet =(evt)=>{
        evt.preventDefault();
        this.clearRefs();
        this._planetRef.current.classList.add('btn-active');
        this.props.goPlanet();
    }


    goHole =(evt)=>{
        evt.preventDefault();
        this.clearRefs();
        this._holeRef.current.classList.add('btn-active');
        this.props.goHole();
    }

    
    toggleMenu =()=>{
        this.setState({menu_open: (this.state.menu_open ? false : true)});
    }


    showInfo =(evt)=>{

        evt.preventDefault();
        this.setState({menu_open: false});
        this.props.showContent('showInfo', true);
    }


    clearRefs = () =>{

        let refs = document.querySelectorAll('.btn-active');

            for (var i = 0; i < refs.length; i++) {
                refs[i].classList.remove('btn-active');
            }
    }


    btnGroup =()=>{

            if(!this.props.ui_locked) return(
                    <div className="btn-group">
                        <button className="btn-active" ref={this._planetRef} onClick={this.goPlanet}><i className="material-icons">fiber_manual_record</i></button>
                        <button ref={this._holeRef}  onClick={this.goHole}><i className="material-icons">trip_origin</i></button>
                    </div>
                )
    }


    restartGame =(evt)=>{
        evt.preventDefault();
        this.props.newGame();
    }


    render(){

        return(
            <header className="block-element">
                 <div>
                    <input type="checkbox" id="menu_toggle" checked={this.state.menu_open} onChange={this.toggleMenu}/>
                    <label id="mainMenuToggle" className="btn" htmlFor="menu_toggle"><i className="material-icons">menu</i></label>
                    <div id="mainMenu" className="content">
                        <ul>
                            <li><a onClick={this.restartGame} href="./">Restart Game</a></li>
                            <li><a href="https://colovr.com/games/">All Games</a></li>
                            <li><a href="./" onClick={this.showInfo}>How to play</a></li>
                            <li><a href="https://colovr.com" target="_blank" rel="noopener noreferrer">coloVR</a></li>
                            <li><a href="https://thesamp.com" target="_blank" rel="noopener noreferrer">EL SAMPO Digital</a></li>
                        </ul>
                    </div>
                </div>

                <a id="headerLogo" href="/play/gueff/">&nbsp;</a>

                {this.btnGroup()}
            </header>
        )
    }
}


export default Header;